exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tiktok-logo {\n  fill: currentColor;\n}\n", ""]);
